import { axiosBackendInstance } from '../axiosInstance'

export class UserAttributionService {
  saveUserAttribution(params) {
    return axiosBackendInstance.post('/api/v1/signupattribution', params)
  }
}
